import React from "react";
import { Link } from "gatsby";
// import PropTypes from "prop-types"
import "./hasuraconfooter.scss";
import footerLogo from "./images/powered-by-hasura-white.svg";
import footerCon from "./images/footer-con.svg";

import twitter from "./images/twitter.svg";
import discord from "./images/discord.svg";
import mail from "./images/mail-footer.svg";
const HasuraConFooter = props => {
  return (
    <section>
      <div className="containerWrapper">
        <div className={"hasuraConFooterWrapper hasuraconFooterTopBorder"}>
          <div className="hasuraConFooter">
            <div className="footerBrand">
              <a href="/">
                <img src={footerLogo} alt="Footer logo" />
              </a>
            </div>
            <div className="footerConBrand">
              <Link to="/events/hasura-con-2020/">
                <img src={footerCon} alt="con logo" />
              </Link>
            </div>
            <a href={"https://twitter.com/hasurahq"} rel="noopener noreferrer" target="_blank">
              <div className="socialWrapper">
                <img src={twitter} alt="Twiiter" />
                <span>
                  Stay updated
                  <br />
                  on Twitter
                </span>
              </div>
            </a>
            {/*
            <a href={"https://discord.gg/6udKJMa"} rel="noopener noreferrer" target="_blank">
              <div className="socialWrapper">
                <img src={discord} alt="discord" />
                <span>
                  Join our Discord
                  <br />
                  community
                </span>
              </div>
            </a>
            */}
            <a href="mailto:events@hasura.io">
              <div className="socialWrapper removeMarBottom">
                <img src={mail} alt="mail" />
                <span>
                  Need help? Get in
                  <br />
                  touch via email
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HasuraConFooter;
